import React from 'react';
import { useIsMobile } from '@guildeducationinc/catalog-tools';
import { Typography } from '@guildeducationinc/recess';
import BookmarkPictogram from '@guildeducationinc/recess/pictograms/BookmarkPictogram';
import BookmarkBorderIcon from '@guildeducationinc/recess/icons/BookmarkBorderIcon';
import styles from './BookmarksCallout.module.scss';

export const BookmarksCallout: React.FC = () => {
	const isMobile = useIsMobile();

	return (
		<section className={styles.wrapper} data-testid='bookmarks-callout'>
			{!isMobile ? <BookmarkPictogram className={styles.pictogram} size={64} /> : null}
			<div>
				<Typography className={styles.title} variant='h2'>
					Welcome to your bookmarks
				</Typography>
				<Typography className={styles.text} variant='body1'>
					Add bookmarks to your favorite programs by clicking the{' '}
					<BookmarkBorderIcon className={styles.icon} size={24} /> icon and make them easy to find
					here.
				</Typography>
			</div>
		</section>
	);
};
